import { IconButton } from "shared/components/IconButton";
import { Select } from "shared/components/forms/Select";
import { Trash02 } from "untitledui-js-base";
import { PropertyOverride } from "views/rent-reporting-settings";
import { STATE_ENROLLMENT_TYPE_OPTIONS } from "../constants";
import { PropertySearchSelect } from "./PropertySearchSelect";

export const PropertyOverrideRow = ({
  override,
  index,
  onUpdate,
  onRemove,
  excludePropertyIds = []
}: {
  override: PropertyOverride;
  index: number;
  onUpdate: (
    index: number,
    field: "propertyId" | "enrollmentType",
    value: string
  ) => void;
  onRemove: (index: number) => void;
  excludePropertyIds?: string[];
}) => {
  return (
    <div className="flex items-center gap-x-4 p-4 border border-dashed border-alpha-100 rounded-lg bg-background-900">
      <div className="flex-1">
        <PropertySearchSelect
          id={`property-${index}-${override.propertyId}`}
          placeholder="Select property"
          value={override.propertyId}
          onChange={(propertyId) => onUpdate(index, "propertyId", propertyId)}
          selectedLabel={override.propertyName}
          className="!mb-0"
          excludePropertyIds={excludePropertyIds}
        />
      </div>
      <div className="flex-1">
        <Select
          id={`enrollment-type-property-${index}-${override.propertyId}`}
          placeholder="Select enrollment type"
          value={override.enrollmentType || undefined}
          onChange={(e) => onUpdate(index, "enrollmentType", e.target.value)}
          options={STATE_ENROLLMENT_TYPE_OPTIONS}
          required
          className="!mb-0"
          menuPlacement="top"
        />
      </div>
      <IconButton Icon={Trash02} onClick={() => onRemove(index)} />
    </div>
  );
};
